import React from "react";
import { useTranslation } from "react-i18next";

const OrderPagination = ({ currentPage, totalPages, onPageChange }) => {

  const {t} = useTranslation()
  const getVisiblePages = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, "...");
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push("...", totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  const visiblePages = totalPages > 1 ? getVisiblePages() : [];

  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center py-4 space-x-2">
      <button
        className="px-4 py-2 border rounded-md select-none hover:bg-green-100 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
           {t("previous")}
      </button>
      {visiblePages.map((page, i) =>
        page === "..." ? (
          <span key={i} className="px-3 py-2 text-gray-500">
            ...
          </span>
        ) : (
          <button
            key={i}
            className={`px-4 py-2 rounded-md select-none border ${
              page === currentPage
                ? "bg-green-200 border-green-400 text-green-900"
                : "border-gray-300 hover:bg-green-50"
            }`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        )
      )}
      <button
        className="px-4 py-2 border rounded-md select-none hover:bg-green-100 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
      {t("next")}
      </button>
    </div>
  );
};

export default OrderPagination;
